export var SupportedNetworkIds;
(function (SupportedNetworkIds) {
    SupportedNetworkIds[SupportedNetworkIds["ETHEREUM_MAINNET"] = 1] = "ETHEREUM_MAINNET";
    SupportedNetworkIds[SupportedNetworkIds["OPTIMISM_MAINNET"] = 10] = "OPTIMISM_MAINNET";
    SupportedNetworkIds[SupportedNetworkIds["ETHEREUM_GOERLI"] = 5] = "ETHEREUM_GOERLI";
    SupportedNetworkIds[SupportedNetworkIds["OPTIMISM_GOERLI"] = 420] = "OPTIMISM_GOERLI";
    SupportedNetworkIds[SupportedNetworkIds["BASE_GOERLI"] = 84531] = "BASE_GOERLI";
})(SupportedNetworkIds || (SupportedNetworkIds = {}));
export var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["AwaitingExecution"] = "AwaitingExecution";
    TransactionStatus["Executed"] = "Executed";
    TransactionStatus["Confirmed"] = "Confirmed";
    TransactionStatus["Failed"] = "Failed";
})(TransactionStatus || (TransactionStatus = {}));
export const NetworkIdByName = {
    mainnet: 1,
    goerli: 5,
    'goerli-ovm': 420,
    'mainnet-ovm': 10,
    'mainnet-fork': 31337,
    'base-goerli': 84531,
};
export const NetworkNameById = {
    1: 'mainnet',
    5: 'goerli',
    10: 'mainnet-ovm',
    420: 'goerli-ovm',
    31337: 'mainnet-fork',
    84531: 'base-goerli',
};
